module.exports = __webpack_public_path__ + "img/logo.4d91fc20.png";